export const environment = {
    production: false,
    // Vercel deployment base URL — used for "Bekijk preview" links from beheer.
    // The ?domain= query param switches the multi-tenant frontend to the
    // selected domain's content without needing live DNS.
    previewBaseUrl: 'https://dwt-cockpit-nextjs.vercel.app',
    firebase: {
        apiKey: "AIzaSyD7ANfz7rfKPEbK_ZmDK0Zg62HBPYupEWs",
        authDomain: "dutch-water-tech.firebaseapp.com",
        databaseURL: "https://dutch-water-tech.firebaseio.com",
        projectId: "dutch-water-tech",
        storageBucket: "dutch-water-tech.appspot.com",
        messagingSenderId: "251770902532",
        appId: "1:251770902532:web:80ee153e9fc2f0268d7d51",
        measurementId: "G-B5PYG8PSFM"
    }
}; 